goog.provide("shadow.js.shim.module$src$svg$wpp$content$smartphone_svg$default");
shadow.js.shim.module$src$svg$wpp$content$smartphone_svg$default = shadow.js.shim.module$src$svg$wpp$content$smartphone_svg.default;
